import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.valor_data_final > _vm.valor_data_inicial)?_c(VIcon,{attrs:{"color":_vm.config_indicador.positivo.cor,"size":15},domProps:{"textContent":_vm._s('mdi-arrow-up')}}):(_vm.valor_data_final < _vm.valor_data_inicial)?_c(VIcon,{attrs:{"color":_vm.config_indicador.negativo.cor,"size":15},domProps:{"textContent":_vm._s('mdi-arrow-down')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }